export default __webpack_public_path__ + "static/media/CR2.882dbd73.png";